import DOMPurify from 'dompurify';

/**
 * Sanitiza uma string HTML para prevenir ataques XSS.
 * @param html - A string HTML a ser sanitizada.
 * @returns A string HTML sanitizada.
 */
export const sanitizeHtml = (html: string): string => {
  if (!html) return '';

  // Clean up any unescaped double quotes inside image alt attributes to prevent browser/DOMPurify parsing errors
  const cleanedHtml = html.replace(/<img\s+([^>]+)>/gi, (imgTag, attrs) => {
    // Look for alt="..." ending before either another attribute or the end of the tag's attributes
    const cleanedAttrs = attrs.replace(/alt="([\s\S]*?)"(?=\s+[a-zA-Z0-9_-]+="|\s*\/??$)/gi, (match, altContent) => {
      const escapedAlt = altContent.replace(/"/g, '&quot;');
      return `alt="${escapedAlt}"`;
    });
    return `<img ${cleanedAttrs}>`;
  });

  return DOMPurify.sanitize(cleanedHtml, {
    ADD_TAGS: ["iframe"],
    ADD_ATTR: ["allow", "allowfullscreen", "frameborder", "scrolling", "referrerpolicy"]
  });
};

